import { render, staticRenderFns } from "./QrCodeGeneration.vue?vue&type=template&id=70e77f3f&"
import script from "./QrCodeGeneration.vue?vue&type=script&lang=ts&"
export * from "./QrCodeGeneration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports